var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63335 0.486115H0V13.6112H4.63335V7.98253C4.63335 6.75445 4.89787 5.82486 5.4269 5.19376C5.97301 4.54561 6.78363 4.22153 7.85877 4.22153C8.57553 4.22153 9.2411 4.37504 9.85546 4.68206V0.25585C9.66774 0.221737 9.49708 0.20468 9.34349 0.20468H8.95951C8.00383 0.20468 7.16761 0.417889 6.45085 0.844306C5.73409 1.25367 5.12825 1.85065 4.63335 2.63526V0.486115ZM20.7267 3.58191C21.2045 3.97421 21.5202 4.49444 21.6738 5.14259H16.3749C16.4944 4.46033 16.776 3.93157 17.2197 3.55632C17.6805 3.18107 18.2692 2.99345 18.986 2.99345C19.6686 2.99345 20.2488 3.1896 20.7267 3.58191ZM19.0628 10.8225C17.1855 10.8225 16.2469 9.82466 16.2469 7.82902H26V7.34291C26 6.20011 25.8379 5.17671 25.5136 4.2727C25.1894 3.35164 24.7201 2.57556 24.1057 1.94446C23.4913 1.31337 22.7404 0.835778 21.853 0.5117C20.9656 0.170566 19.9673 0 18.858 0C17.7316 0 16.7162 0.170566 15.8118 0.5117C14.9243 0.835778 14.1649 1.30484 13.5335 1.91888C12.902 2.53292 12.4157 3.28341 12.0744 4.17036C11.733 5.04025 11.5624 6.02101 11.5624 7.11264C11.5624 8.17016 11.7416 9.12533 12.1 9.97817C12.4583 10.831 12.9618 11.5644 13.6103 12.1785C14.2758 12.7925 15.0694 13.2701 15.9909 13.6112C16.9125 13.9353 17.9279 14.0974 19.0372 14.0974C22.6551 14.0974 24.9163 12.5964 25.8208 9.59439H21.3411C20.8291 10.4131 20.0697 10.8225 19.0628 10.8225Z",
    fill: "url(#paint0_linear_2837_22504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2837_22504",
    x1: -52.6972,
    y1: -1.65749,
    x2: 99.666,
    y2: 6.94479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FB44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671842,
    stopColor: "#7BD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0DBF9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestream);
export default __webpack_public_path__ + "static/media/restream.0ed39d6c951d19c76dcc5af87267ba9e.svg";
export { ForwardRef as ReactComponent };